import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NamesToUpdateService } from '../../services/raintree/Transmission/names-to-update.service';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Validation } from '../../services/common/app.constant';
import { AssignDataRes } from '../../services/raintree/interfaces/names-to-update.interface';
import { DpBottomSheetCloserComponent } from "../../common-component/dp-bottom-sheet-closer/dp-bottom-sheet-closer.component";

@Component({
  selector: 'app-edit-details-bottom-sheet',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, DpBottomSheetCloserComponent],
  templateUrl: './edit-details-bottom-sheet.component.html',
  styleUrl: './edit-details-bottom-sheet.component.scss'
})
export class EditDetailsBottomSheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private _namesToUpdateService: NamesToUpdateService,
    private bottomSheetRef: MatBottomSheetRef<EditDetailsBottomSheetComponent>
  ) { }

  editDetailsForm = new FormGroup({
    serialNo: new FormControl(null),
    contactNo: new FormControl('',[Validators.pattern(Validation.regex.phone)]),
    address: new FormControl('',[Validators.pattern('^[^*]*$')]),
  });
  ngOnInit(): void {
    console.log(this.data)
    this.editDetailsForm.patchValue({
      serialNo: this.data.serialNo,
      contactNo: this.data.contact,
      address: this.data.addr,
    });
  }
  getFormValue(controlName: string): any {
    return this.editDetailsForm.get(controlName)?.value;
  }

  clearSerialNo() {
    this.editDetailsForm.get('serialNo')?.setValue(null);
  }

  editDetails() {
    let bodyObj = {
      dpwMemKey: this.getFormValue('serialNo'),
      contactNo: this.getFormValue('contactNo'),
      address: this.getFormValue('address'),
    };
    if (this.editDetailsForm.valid) {
      this._namesToUpdateService.editDetails(this.data.id, bodyObj).subscribe({
        next: (res: AssignDataRes) => {
          this.bottomSheetRef.dismiss();
        },
        error: (error) => console.log(error),
      });
    } else {

      this.editDetailsForm.markAllAsTouched();


    }

  }

  closesheet():void{
    this.bottomSheetRef.dismiss();
  }

}
